import { useLayoutEffect } from 'react';
import { useAuth } from 'react-oidc-context';
import { useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';
import { Paths } from '@src/routes/paths';
import { renewSession } from '@src/auth/tokenRefresh';
import { LoadingSpinner } from '@components/atoms/LoadingSpinner.tsx';
import { setStoredLanguage, toSupportedLocale } from '@utils/language';

export function RefreshView() {
  const auth = useAuth();
  const navigate = useNavigate();
  const { i18n } = useTranslation('language');

  useLayoutEffect(() => {
    // Goes through renewSession so this shares the app-wide in-flight guard with
    // the api client rather than firing a second parallel renewal.
    void renewSession().then((user) => {
      const locale = toSupportedLocale(user?.profile?.locale);
      if (locale) {
        void i18n.changeLanguage(locale);
        setStoredLanguage(locale);
      }
      // Navigate even when the renewal failed: the secured-route loader then
      // sends the user to login instead of leaving them on a spinner forever.
      navigate(Paths.PROFILE, { replace: true });
    });
  }, [i18n, navigate]);

  if (auth.error) {
    throw auth.error;
  }

  return <LoadingSpinner />;
}
